<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" style = "max-width: 1100px;">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">{{'Manage ShutOff ('+ list.name + ')'}}</h5>
					</div>
					<div class ="form-group row" style ="padding-top : 10px" v-if="!showLoader">
						<div class ="col-sm-3 mso-popover-style">
							<span style="">
								AMS Pause
								<toggle-button v-model="ams_shutoff" :sync = "true" style = "padding-left : 5px"/>
							</span>
						</div>
						<div class = "col-sm-8">
							<MNSODateSelector
							type="ams_shutoff"
							v-if = "ams_shutoff"
							:isEdit="isEdit"
							@setAmsShutOffDate = "setAmsShutOffDate"
							@setAmsShutOffDateNull = "setAmsShutOffDateNull"
							:start_date_ams = "start_date_ams"
							:end_date_ams = "end_date_ams"
							/>
						</div>
					</div>
					<div class="" style = "border-top:1px dotted #dee2e6" v-if="!showLoader">
						<div class = "form-group row" style="padding-top:10px">
							<div class ="col-sm-3 mso-popover-style">
								<span style="">
									ML ShutOff (MLSO)
									<toggle-button v-model="ml_shutoff" :disabled = "ams_shutoff" color = "rgb(232, 210, 174)" :sync = "true" style = "padding-left : 5px"/>
								</span>
							</div>
							<div class ="col-sm-8">
								<MNSODateSelector
								type="ams_mlso"
								v-if = "!ams_shutoff && ml_shutoff"
								:isEdit="isEdit"
								@setAmsMLSODate = "setAmsMLSODate"
								@setAmsMLSODateNull = "setAmsMLSODateNull"
								:start_date_ml = "start_date_ml"
								:end_date_ml = "end_date_ml"
								/>
							</div>
						</div>
						<div style="background-color:#f7f7f7;padding-top:10px" class="popup_border">
							<div class = "form-group row" style="padding-top:10px;">
								<div class ="col-sm-3 mso-popover-style">
									<span style="">
										Midnight ShutOff (MNSO)
										<toggle-button v-model="midnight_shutoff" :disabled = "ams_shutoff||manageDayParting" color = "rgb(255, 102, 153)" :sync = "true" style = "padding-left : 5px"/>
									</span>
								</div>
								<div class ="col-sm-8" >
									<MNSODateSelector
									type="ams_mnso"
									v-if = "!ams_shutoff && midnight_shutoff"
									:isEdit="isEdit"
									@setMNSODate = "setMNSODate"
									:start_date_midnight = "start_date_midnight"
									:end_date_midnight = "end_date_midnight"
									:mnso_start_time = "mnso_start_time"
									:mnso_end_time = "mnso_end_time"
									@updateMNSOTime = "updateMNSOTime"
									@setMNSODateNull = "setMNSODateNull"
									@updateMNSOEndTime = "updateMNSOEndTime"
									/>
								</div>
							</div>
							<div class = "form-group row" style="padding-top:10px;padding-bottom:10px">
								<div class ="col-sm-3 mso-popover-style">
									<span style="">
										Manage Day Parting
										<toggle-button v-model="manageDayParting" :disabled = "ams_shutoff||midnight_shutoff" :sync = "true" style = "padding-left : 5px"/>
									</span>
								</div>
								<div class ="col-sm-8" v-if="!ams_shutoff && manageDayParting">
								
									<DayPartingData
										:partingStartTime="partingStartTime"
										:partingEndTime="partingEndTime"
										:partingStartDate="partingStartDate"
										:partingEndDate="partingEndDate"
										@updateTime="partingTimeUpdated"
										@updateDate="partingDateUpdated"
									/>
								</div>
							</div>
						</div>
						<div v-if = "isMissingValue" class = "mso-popover-style" style = "color : red"><p>Select Date, Time and Flag to Continue.</p></div>
						<!-- <div class ="row" style ="padding-top : 10px;padding-bottom : 15px;">
							<div class ="msg-style">
								<p class = "msg-text-style" style = "">{{'Update will happen in the first hour of the selected start/end date except for today. Update for today becomes effective immediately.'}}</p>
							</div>
						</div> -->
						<div class="modal-footer" style = "display: flex ; justify-content : center">
							<button type="button" @click="hideModal()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button
							type="button"
							class="btn btn-primary"
							@click = "saveMnsoDetails()"
							>Save changes</button>
						</div>
					</div>
					<div class="row" style ="padding-top : 10px" v-if="showLoader">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import DayPartingData from './DayPartingData'
import MNSODateSelector from './MNSODateSelector'
var moment = require("moment");

export default {
	name : 'MNSOFlagPopUp',
	components : {
		MNSODateSelector,
		DayPartingData
	},

	data(){
		return{
			manageDayParting: this.list.day_parting || this.list.shutoff_for === 'day_parting',
			partingStartTime: this.list.mnso_start_time,
			partingEndTime: this.list.mnso_end_time,
			partingStartDate: this.list.start_date_midnight,
			partingEndDate: this.list.end_date_midnight,
			ams_shutoff : this.list.ams_shutoff || !!this.list.start_date_ams,
			ml_shutoff : this.list.ml_shutoff || !!this.list.start_date_ml,
			midnight_shutoff : this.list.midnight_shutoff || this.list.shutoff_for === 'mnso',
			showValues : false,
			//TODO: investigate purpose of isEdit
			isEdit : this.list.ams_shutoff || this.list.ml_shutoff || this.list.midnight_shutoff || this.list.manageDayParting,
			start_date_ams : this.list.start_date_ams ,
			end_date_ams :  this.list.end_date_ams,
			start_date_ml : this.list.start_date_ml ,
			end_date_ml : this.list.end_date_ml ,
			start_date_midnight : this.list.start_date_midnight,
			end_date_midnight : this.list.end_date_midnight,
			showLoader:false,
			isMissingValue : false,
			mnso_start_time: this.list.mnso_start_time || '00:15',
			mnso_end_time: this.list.mnso_end_time || '06:15'
		}
	},
	watch:{
		manageDayParting(){
			this.isMissingValue = false
			if(this.manageDayParting == false){
				this.partingStartDate = this.partingStartDate ? moment(this.partingStartDate).format('YYYY-MM-DD') : null
				this.partingEndDate = this.partingEndDate ? moment(this.partingEndDate).format('YYYY-MM-DD') : null
			}
		},
		ams_shutoff(){
			this.isMissingValue = false
			if(this.ams_shutoff == false){
				this.start_date_ams =  this.start_date_ams ? moment(this.start_date_ams).format('YYYY-MM-DD') : null
				this.end_date_ams =  this.end_date_ams ? moment(this.end_date_ams).format('YYYY-MM-DD') : null
			}
			if(this.ams_shutoff == true){
				this.ml_shutoff = false
				this.midnight_shutoff = false
				this.manageDayParting = false
			}
		},
		ml_shutoff(){
			
			this.isMissingValue = false

			if(this.ml_shutoff == false){
				this.start_date_ml = this.start_date_ml ? moment(this.start_date_ml).format('YYYY-MM-DD') : null
				this.end_date_ml = this.end_date_ml ? moment(this.end_date_ml).format('YYYY-MM-DD') : null
			}
		},
		midnight_shutoff(){

			this.isMissingValue = false
			if(this.midnight_shutoff == false){
				this.start_date_midnight = this.start_date_midnight ? moment(this.start_date_midnight).format('YYYY-MM-DD') : null
				this.end_date_midnight = this.end_date_midnight ? moment(this.end_date_midnight).format('YYYY-MM-DD') : null
			}
		}
	},
	props:{
		list : Object,
		showModal : Boolean
	},
	//mounted(){
		// this.midnight_shutoff = false
		// this.manageDayParting = false
		// if(this.list.shutoff_for == 'mnso' && this.list.start_date_midnight){
		// 	this.midnight_shutoff = true
		// }
		// else if(this.list.shutoff_for == 'day_parting' && this.list.start_date_midnight){
		// 	this.manageDayParting = true
		// }
		// this.manageDayParting = this.list.day_parting || this.list.shutoff_for == 'day_parting'
		// this.midnight_shutoff = this.list.midnight_shutoff || this.list.shutoff_for == 'mnso'
		// if(this.midnight_shutoff){
		// 	this.start_date_midnight = this.list.start_date_midnight||''
		// 	this.end_date_midnight = this.list.end_date_midnight||''
		// 	this.mnso_start_time= this.list.mnso_start_time ? this.list.mnso_start_time : '00:15',
		// 	this.mnso_end_time= this.list.mnso_end_time ? this.list.mnso_end_time : '06:15'
		// }
		// else if(this.manageDayParting){
		// 	this.partingStartTime=this.list.mnso_start_time ? this.list.mnso_start_time : null,
		// 	this.partingEndTime=this.list.mnso_end_time ? this.list.mnso_end_time : null,
		// 	this.partingStartDate=this.list.start_date_midnight||'',
		// 	this.partingEndDate=this.list.end_date_midnight||''
		// }
		// if(!this.ams_shutoff && !this.ml_shutoff && !this.midnight_shutoff && !this.manageDayParting){
		// 	this.isEdit = false
		// }
	//},
	methods : {
		partingTimeUpdated(type,val){
			if(type=='startTime'){
				this.partingStartTime = val
			}
			else if(type=='endTime'){
				this.partingEndTime = val
			}
		},
		partingDateUpdated(type,val){
			if(type=='startDate'){
				this.partingStartDate = val
			}
			else if(type=='endDate'){
				this.partingEndDate = val
			}
		},
		setAmsShutOffDateNull(){
			this.end_date_ams = null
		},
		setAmsMLSODateNull(){
			this.end_date_ml = null
		},
		setMNSODateNull(){
			this.start_date_midnight = null
		},
		setAmsShutOffDate(data){
			this.isMissingValue = false;
			if(data.type == 'end' && data.date){
				this.end_date_ams = moment(data.date)
			}
			else if(data.type == 'start' && data.date){
				this.start_date_ams = moment(data.date)
			}
		},
		setAmsMLSODate(data){
			
			this.isMissingValue = false;
			if(data.type == 'end'  && data.date){
				this.end_date_ml = moment(data.date)
			}
			else if(data.type == 'start' && data.date){
				this.start_date_ml = moment(data.date)
			}
		},
		setMNSODate(data){
			
			this.isMissingValue = false;
			if(data.type == 'end'  && data.date){
				this.end_date_midnight = moment(data.date)
			}
			else if(data.type == 'start' && data.date){
				this.start_date_midnight = moment(data.date)
			}
		},
		updateMNSOTime(data){

			this.mnso_start_time = data
		},
		updateMNSOEndTime(data){
			this.mnso_end_time = data
		},
		saveMnsoDetails(){
			let item = this.list;
			let vm = this;

			if(this.ams_shutoff){
				this.midnight_shutoff = false
				this.ml_shutoff = false
				this.start_date_ml = null
				this.end_date_ml = null
				this.start_date_midnight = null
				this.end_date_midnight = null
			}

			if(this.ml_shutoff || this.midnight_shutoff || this.manageDayParting){
				this.ams_shutoff = false
				this.start_date_ams = null
				this.end_date_ams = null
			}

			if(!this.ml_shutoff){
				this.start_date_ml = null;
				this.end_date_ml = null;
			}
			if(!this.midnight_shutoff){
				this.start_date_midnight = null;
				this.end_date_midnight = null;
			}
			if(!this.ams_shutoff){
				this.start_date_ams = null;
				this.end_date_ams = null;
			}
			if(!this.manageDayParting){
				this.partingStartDate = null
				this.partingEndDate = null
				this.partingStartTime = null
				this.partingEndTime = null
			}

			var save_payload = {
				campaign_id : item.campaign_id,
				//campaignGroupId : (this.$route.params.groupId ? this.$route.params.groupId : ''),
				midnight_shutoff : this.midnight_shutoff,
				ams_shutoff : this.ams_shutoff,
				ml_shutoff : this.ml_shutoff,
				day_parting : this.manageDayParting,
				start_date_ams :(this.start_date_ams ? moment(this.start_date_ams).format("YYYY-MM-DD") : null),
				end_date_ams : (this.end_date_ams ? moment(this.end_date_ams).format("YYYY-MM-DD") : null),
				start_date_ml : (this.start_date_ml ? moment(this.start_date_ml).format("YYYY-MM-DD") : null),
				end_date_ml : (this.end_date_ml ? moment(this.end_date_ml).format("YYYY-MM-DD") : null),


				start_date_midnight : (this.start_date_midnight ? moment(this.start_date_midnight).format("YYYY-MM-DD") : null),
				end_date_midnight : (this.end_date_midnight ? moment(this.end_date_midnight).format("YYYY-MM-DD") : null),
				mnso_start_time : (this.mnso_start_time && this.midnight_shutoff  ? this.mnso_start_time : ''),
				mnso_end_time : (this.mnso_end_time && this.midnight_shutoff  ? this.mnso_end_time : ''),


				// day_parting_start_date: this.partingStartDate? moment(this.partingStartDate).format("YYYY-MM-DD") : null,
				// day_parting_end_date: this.partingEndDate?moment(this.partingEndDate).format("YYYY-MM-DD") : null,
				// day_parting_enable_time: (this.partingStartTime && this.manageDayParting) ? this.partingStartTime : '',
				// day_parting_pause_time: (this.partingEndTime && this.manageDayParting) ? this.partingEndTime : '',
				
				
			}
			if((this.midnight_shutoff && this.start_date_midnight) || (this.ams_shutoff && this.start_date_ams) || (this.ml_shutoff && this.start_date_ml) || (this.manageDayParting && this.partingStartDate)){

				if((this.midnight_shutoff && !this.start_date_midnight) || (this.ams_shutoff && !this.start_date_ams) || (this.ml_shutoff && !this.start_date_ml) || (this.manageDayParting && (!this.partingStartDate || !this.partingStartTime || !this.partingEndTime))){
					this.isMissingValue = true
				}
				else{
					//update mnso details with day parting details in payload, if day parting flag is true
					if(this.manageDayParting){
						save_payload['start_date_midnight']= this.partingStartDate? moment(this.partingStartDate).format("YYYY-MM-DD") : null,
						save_payload['end_date_midnight']= this.partingEndDate?moment(this.partingEndDate).format("YYYY-MM-DD") : null,
						save_payload['mnso_start_time']= (this.partingStartTime) ? this.partingStartTime : '',
						save_payload['mnso_end_time']= (this.partingEndTime) ? this.partingEndTime : ''
						save_payload['shutoff_for']= 'day_parting'
					}
					else if(this.midnight_shutoff){
						save_payload['shutoff_for']= 'mnso'
					}

					this.showLoader = true;
					console.log('save payload: ' + JSON.stringify(save_payload))
					this.$store.dispatch('campaign/updateMNSOStatus',save_payload).then((res) => {
						if(res){
							vm.$emit('hideMSOModal',false)
							vm.showLoader = false;
						}
					})
				}

			}
			else if(!this.midnight_shutoff && !this.ams_shutoff && !this.ml_shutoff && !this.manageDayParting){
				this.showLoader = true;
				this.start_date_ams = null
				this.end_date_ams = null
				this.start_date_ml = null
				this.end_date_ml = null
				this.start_date_midnight = null
				this.end_date_midnight = null
				this.mnso_start_time = null
				this.mnso_end_time = null

				this.manageDayParting = false
				this.partingStartDate = null
				this.partingEndDate = null
				this.partingStartTime = null
				this.partingEndTime = null

				let payload = {
					campaign_id : item.campaign_id,
					//campaignGroupId : (this.$route.params.groupId ? this.$route.params.groupId : ''),
					midnight_shutoff : this.midnight_shutoff,
					ams_shutoff : this.ams_shutoff,
					ml_shutoff : this.ml_shutoff,
					start_date_ams : this.start_date_ams,
					end_date_ams : this.end_date_ams,
					start_date_ml : this.start_date_ml,
					end_date_ml : this.end_date_ml,
					start_date_midnight : this.start_date_midnight,
					end_date_midnight : this.end_date_midnight,
					mnso_start_time: this.mnso_start_time,
					mnso_end_time: this.mnso_end_time,

					day_parting:this.manageDayParting,
					shutoff_for:null
				}

				this.$store.dispatch('campaign/updateMNSOStatus',payload).then((res) => {
					if(res){
						vm.$emit('hideMSOModal',false)
						vm.showLoader = false;
					}
				})

			}
			else{
				this.isMissingValue = true
			}

		},
		// updateToggleValues(){
		// 	console.log('triggered');
		// 	this.ams_shutoff = this.list.ams_shutoff;
		// 	this.ml_shutoff = this.list.ml_shutoff;
		// 	this.midnight_shutoff = this.list.midnight_shutoff;
		// 	this.showValues = true;
		// },
		hideModal(){
			this.$emit('closeMSOModal',false)
		}
	}
}
</script>

<style lang="scss">
.mso-popover-style{
  /* display : flex; */
  /* justify-content: center;
  align-items: center; */
  margin-left: 20px;
  padding-top:10px;
}
/* .popover.fade.show.bs-popover-left {
   max-width : 310px !important
} */

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  max-width:800px;
  margin: 0px auto;
  padding-top:0px;
  background-color: #fff;
  border-radius: .3rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.msg-style{
	width:100%;
	border:1px red solid;
	margin-left: 30px;
	margin-right: 30px;
	text-align: left;
}

.msg-text-style{
	font-size:15px;
	color:red;
	margin:0px;
	padding: 12px;
	font-weight: 500;
}
.popup_border{
	border-top: 1px dotted #dee2e6;
    width: 100%;
}
</style>
